import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { LinkedCardType } from '@superthread-com/api';
import { computed } from 'vue';
import RelatedCardsTooltip from '@/components/tooltips/RelatedCardsTooltip.vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';


export default /*@__PURE__*/_defineComponent({
  __name: 'RelationsMeta',
  props: {
  cards: {
    type: Array,
    required: true,
  },
  relationType: {
    type: String,
    required: true,
  },
  renderTooltip: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const { iconPath, getCustomIconStyle } = useCustomIcon();

const props = __props;

const getIconSyle = computed(() => {
  let style = {};
  switch (props.relationType) {
    case LinkedCardType.BlockedBy:
      style = { ...getCustomIconStyle(iconPath('flag')), backgroundColor: '#FDB022' };
      break;
    case LinkedCardType.Blocks:
      style = { ...getCustomIconStyle(iconPath('black-flag')), backgroundColor: '#F97066' };
      break;
    default:
      break;
  }
  return style;
});

return (_ctx: any,_cache: any) => {
  const _component_v_popover = _resolveComponent("v-popover")!

  return (_openBlock(), _createBlock(_component_v_popover, {
    tag: "div",
    "content-tag": "div",
    placement: "top",
    class: "footer-icon-wrap",
    role: 'poper',
    "on-show": () => __props.renderTooltip
  }, {
    content: _withCtx(({ state }) => [
      (state.isVisible)
        ? (_openBlock(), _createBlock(RelatedCardsTooltip, {
            key: 0,
            cards: __props.cards,
            "relation-type": __props.relationType
          }, null, 8, ["cards", "relation-type"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("em", {
        style: _normalizeStyle(getIconSyle.value),
        class: "custom-icons small-card-info-icons"
      }, null, 4),
      _cache[0] || (_cache[0] = _createTextVNode())
    ]),
    _: 1
  }, 8, ["on-show"]))
}
}

})